import Vue from "vue";

export default {
  SET_LANDINGPAGE(state, payload) {
    // console.log(payload);
    state.landingPageDetails = payload;
  },
};
